import { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import 'assets/Table.scss';

interface TableProps {
    booked: string[];
    location: string;
    booking: string;
    toggle: (location: string) => void;
    right?: boolean;
    flip?: boolean;
    rowstart?: boolean;
    disabled?: boolean;
    blocked?: boolean;
    rotate?: boolean;
    allowSelectOccupied?: boolean;
}

const Table: FC<TableProps> = (props: TableProps) => {
    const [booked, setBooked] = useState(false);

    useEffect(() => {
        const isBooked = props.booked.includes(props.location);
        setBooked(isBooked);
    }, [props.booked, props.location]);

    const isOwnBooking = props.booking === props.location;
    const isVisuallyBlocked = (props.blocked || props.disabled) && !booked && !isOwnBooking;

    const onTableClick = () => {
        if (props.disabled) {
            return;
        }
        if (booked && !isOwnBooking && !props.allowSelectOccupied) {
            return;
        }
        props.toggle(props.location);
    };

    const tableClasses = classNames('table', { 'table-upside-down': props.flip, 'table-rotate': !!props.rotate });
    const tableNumberClass = classNames('table-normal', 'table-part', { 'table-upside-down': props.flip });
    const buttonClass = classNames(
        'table-button',
        { 'table-booking': isOwnBooking },
        { 'table-free': !booked && !isVisuallyBlocked && !isOwnBooking },
        { 'table-booked': booked && !isOwnBooking },
        { 'table-disabled': isVisuallyBlocked },
        { 'table-unclickable': props.disabled }
    );

    return (
        <div className={tableClasses}>
            <div />
            <div className="table-part table-chair" />
            <div />
            <div>
                <button className={buttonClass} onClick={onTableClick} disabled={props.disabled} type="button">
                    <div className={tableNumberClass}>
                        <span className={'location-label'}>{props.location}</span>
                    </div>
                </button>
            </div>
        </div>
    );
};

export default Table;
